import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@app/context/ModalsContext'

import { Body2 } from '@ui/Typography'
import { Modal } from '@ui/components/Modal'

import { Box } from '@shared/components/Box'

import styles from './FormulaForRewards.module.scss'

export const FormulaForRewardsModal: BaseModalType = ({ close }) => {
  const { t } = useTranslation()

  const payoutSchemeModalDescriptions = [
    t('IB.MultiTier.Formula for rewards.Formula tab.L'),
    t('IB.MultiTier.Formula for rewards.Formula tab.CS'),
    t('IB.MultiTier.Formula for rewards.Formula tab.SM'),
    t('IB.MultiTier.Formula for rewards.Formula tab.Rate'),
    t('IB.MultiTier.Formula for rewards.Formula tab.TSS'),
  ]

  return (
    <Modal>
      <Modal.Header>{t('IB.MultiTier.IB Commission Plans')}</Modal.Header>
      <Modal.Body centered>
        <Box className={styles.formulaContainer}>
          <Body2>{t('IB.Dashboard.Your Payout Scheme.Classic Account Calculation Formula')}</Body2>

          <div className={styles.formulaTitleContainer}>
            <Body2>{t('IB.MultiTier.Formula for rewards.MLC Calculation Formula')}</Body2>
          </div>

          <div>
            <Modal.Body.List noListStyle>
              {payoutSchemeModalDescriptions.map((description, index) => (
                <Modal.Body.List.Item key={index} size='body2'>
                  {description}
                </Modal.Body.List.Item>
              ))}
            </Modal.Body.List>
          </div>
        </Box>
      </Modal.Body>

      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Close')}</Modal.Footer.Secondary>
      </Modal.Footer>
    </Modal>
  )
}
